import { msalInstance } from "./msalInstance";
import { microsoftRequest } from "./EnvironmentVariables";
import { AuthType } from '@shared/utils/AuthUtils';
import { getStoreRef } from './storeRef';

export async function getMsalTokens(): Promise<{ idToken: string; accessToken: string }> {
  const account = msalInstance.getActiveAccount() ?? msalInstance.getAllAccounts()[0];
  if (!account) {
    throw new Error('No authenticated MSAL account');
  }

  const result = await msalInstance.acquireTokenSilent({
    ...microsoftRequest.login,
    redirectUri: `${window.location.origin}/blank.html`,
    account,
    forceRefresh: false,
  });

  return {
    idToken: result.idToken,
    accessToken: result.accessToken,
  };
}

export function isMsalAuth(): boolean {
  return getStoreRef()?.getState().auth.authType === AuthType.Microsoft;
}
